import { config } from '../dependencies';

export const InitialValues = config.companyFormInitialValues;
